import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../../shared/components/DashboardHeader';
import SideMenu from '../../shared/components/SideMenu';
import Footer from '../../shared/components/Footer';

import HttpCall from '../../api/Http';
import SerializeClass from '../../shared/Utils/serialized';
import User from '../../shared/Utils/User';
import axios from 'axios';
import Alert from '../../shared/Utils/AlertBox';
import Loader from '../../shared/components/Loader';
import validator from 'validator'
import Moment from 'react-moment';
import { HubConnectionBuilder } from "@microsoft/signalr";

import swal from 'sweetalert';


export default function Platform() {

  const [sequenceList, setSequenceList] = useState([])
  const [platformID, setPlatformID] = useState(0);
  const [platformList, setPlatformList] = useState([])
  const [sequenceID, setsequenceID] = useState(0)
  const [connectionID, setconnectionID] = useState(0)
  const [loader, setLoader] = useState(false);
  const [inputValue, setInputValue] = useState({ email: "", password: "", url: "", searchText: "" });
  const { email, password, url, searchText } = inputValue;
  const [step1, setStep1] = useState(false);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [step4, setStep4] = useState(false);
  const [verificationCode, setVerificationCode] = useState("")
  const user = User.getUser()
  const [socketData, setsocketData] = useState({})

  const [connection, setConnectionn] = useState(new HubConnectionBuilder().withUrl("https://api.getbound.ai/api/socket").build())


  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value, }));
  };

  useEffect(() => {

    getPlatformList(0);

    connection.start().then(() => {
      setconnectionID(connection.connectionId)
      connection.on('authorization_response', data => {
        data['client_connection_id'] = connection.connectionId;
        if (data.status == 3) {
          setStep1(true);
          setStep2(false);
          setStep3(true);
          getPlatformList(0);
          return;
        }
        else if (data.status == 2) {
          setStep1(false);
          setStep2(true);
          let p = {
            'client_connection_id': data.connection_id,
            'connection_id': connection.connectionId,
            'platform_id': data.platform_id
          };
          setsocketData(p);
        }
        else if (data.status == 4) {
          setStep1(false);
          setStep2(false);
          setStep3(false);
          setStep4(true);
        }

      })
    })
  }, [])

  const getPlatformList = (type) => {

    let arr = [];
    arr.push({ P_user_id: user[0].Id });
    if (type == 0)
      arr.push({ P_Search_Text: searchText });
    let p = SerializeClass.getSerializedData(arr);
    let header = {
      headers: { 'Authorization': `Token ${user[0].token}` }
    };
    let url = `https://api.getbound.ai/api/user/getUserSequence?Params=${p}`;
    axios.get(url, header).then(response => {
      if (response.data.code == 200) {
        setSequenceList(response.data.data);
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      console.log(err);
    })

    let url2 = `https://api.getbound.ai/api/user/getUserPlatforms?Params=${p}`;
    axios.get(url2, header).then(response => {
      if (response.data.code == 200) {
        setPlatformList(response.data.data);
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      console.log(err);
    })
  }

  function selectChanged(e) {
    const select = e.target;
    setsequenceID(select.children[select.selectedIndex].value);
  }

  function addPlatform(e) {

    e.preventDefault();
    if (sequenceID == 0) {
      return Alert.show('Error', 'Please select the sequence name', 'error')
    }
    if (!validator.isEmail(email)) {
      return Alert.show('Error', 'Please enter the valid email', 'error')
    }
    if (!password) {
      return Alert.show("Error!", 'Please enter the password', "error");
    }
    if (!validator.isURL(url)) {
      return Alert.show("Error!", 'Please enter the valid website url', "error");
    }

    let requestData = new FormData();
    let arr = [];

    if (platformID > 0) {
      arr.push({ P_id: platformID });
      arr.push({ P_updated_by: user[0].Id });
    } else {
      arr.push({ P_user_id: user[0].Id });
      arr.push({ P_created_by: user[0].Id });
    }
    arr.push({ P_sequence_id: sequenceID });
    arr.push({ P_login_id: email });
    arr.push({ P_login_password: password });
    arr.push({ P_url: url });
    let p = SerializeClass.getSerializedData(arr);
    let rurl = platformID ? `/api/user/updatePlatform` : `/api/user/addPlatform`;
    requestData.append('Params', p);
    setLoader(true)
    HttpCall.postRequest2(rurl, requestData).then(response => {
      if (response.data.code == 200) {
        Alert.show("Success!", platformID ? "Plaform Updated Successfully." : "Plaform Added Successfully.", "success");
        getPlatformList(0);
        setLoader(false);
        setInputValue({ email: "", password: "", url: "" });
        setsequenceID(0);
      } else {
        Alert.show("Error!", response.data.msg, "error");
        setLoader(false);
      }
    }).catch(err => {
      console.log(err);
      setLoader(false);
    })
  }

  function editPlatform(row) {
    setPlatformID(row.id);
    setsequenceID(row.sequence_id)
    setInputValue(() => ({ email: row.login_id, password: row.login_password, url: row._url }))
  }

  function Verify(row) {

    let requestData = new FormData();
    let arr = [];
    arr.push({ P_platform_id: row.id });
    arr.push({ P_connection_id: connectionID });
    arr.push({ P_user_id: user[0].Id });
    let p = SerializeClass.getSerializedData(arr);
    let rurl = `/api/user/AddAuthorizationRequest`;
    requestData.append('Params', p);
    setStep1(true);
    HttpCall.postRequest2(rurl, requestData).then(response => {
      if (response.data.code == 200) {

        //Alert.show( "Success!",  "Request Initiated for the verification", "success");
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      setStep1(false);
    })
  }

  function sendCodeRequest() {
    socketData['code'] = verificationCode;
    let p = socketData;
    p['code'] = verificationCode;
    setStep1(true);
    setStep2(false);
    HttpCall.postRequest2('/api/live/socket/authRequest', p).then(response => {
      setVerificationCode("");
    }).catch(err => {
      console.log(err);
      setLoader(false);
    })
  }

  function closePopup() {
    setStep1(false);
    setStep2(false);
    setStep3(false);
    setStep4(false);
  }

  function searchRecord(e) {
    e.preventDefault();
    getPlatformList(0);
  }

  function clearSearch(e) {
    inputValue.searchText = '';
    e.preventDefault();
    getPlatformList(1);
  }

  return (
    <>
      <DashboardHeader />
      {loader && <Loader />}
      <div className="container-fluid page-body-wrapper">

        <SideMenu />

        {step1 && <div id="RequestModal" class="modal" style={{ display: 'block' }}>
          <div class="modal-content">
            {/* <span class="close1 closebtn">&times;</span> */}
            <i class="mdi mdi-timer-sand"></i>
            <h1>Processing Verification Request...</h1>
            <h2>This may take a while</h2>
            {/* <button type="button" class="btn btn-primary btn-rounded btn-md">OK</button> */}
          </div>
        </div>}

        {step2 && <div id="VerificationCode" class="modal" style={{ display: 'block' }}>
          <div class="modal-content">
            <i class="mdi mdi-link-variant"></i>
            <h1>Enter the verification code</h1>
            <input type="text" class="text-center form-control form-control-lg"
              id="exampleInputPassword1" placeholder="XXXXXXXX" suggesstion="off"
              name="verificationCode" value={verificationCode} onChange={(e) => setVerificationCode(e.target.value)} />
            <button type="button" class="btn btn-primary btn-rounded btn-md" onClick={sendCodeRequest}>OK</button>
          </div>
        </div>}

        {step3 && <div id="SuccessfullyModal" class="modal" style={{ display: 'block' }}>
          <div class="modal-content">
            <span class="close3 closebtn">&times;</span>
            <i class="mdi mdi-checkbox-marked-circle-outline"></i>
            <h1>Your account has been Successfully Verified!</h1>
            <button type="button" class="btn btn-primary btn-rounded btn-md" onClick={closePopup}>OK</button>
          </div>
        </div>}

        {step4 && <div id="FailModal" class="modal" style={{ display: 'block' }}>
          <div class="modal-content">
            <span class="close3 closebtn">&times;</span>
            <i class="mdi mdi-alert-circle-outline"></i>
            <h1>Please check your credentials and try again!</h1>
            <button type="button" class="btn btn-primary btn-rounded btn-md" onClick={closePopup}>OK</button>
          </div>
        </div>}


        <div className="main-panel">

          <div className="content-wrapper">
            <div className="row">

              <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Sequence > Define Platform</h4>
                    <p className="card-description">
                      Note: Provide credentials of the platform(s) to engage with AI Engine
                    </p>
                    <form className="forms-sample">

                      <div className="form-group">
                        <label>Sequence Name</label>
                        <select className="js-example-basic-single w-100 customselect form-control form-control-lg" onChange={selectChanged} value={sequenceID}>
                          <option value="">Sequence Name</option>
                          {sequenceList.map(data => (
                            <option key={data.id} value={data.id}>
                              {data.sequence_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Email address</label>
                        <input type="email" className="form-control form-control-lg" id="exampleInputEmail1"
                          name="email" value={email} onChange={handleChange}
                          placeholder="example@email.com" />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Password</label>
                        <input type="password" className="form-control form-control-lg" id="exampleInputPassword1"
                          name="password" value={password} onChange={handleChange}
                          placeholder="*********" />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">URL</label>
                        <input type="text" className="form-control form-control-lg" id="exampleInputUsername1"
                          name="url" value={url} onChange={handleChange}
                          placeholder="https://exmaple.com/" />
                      </div>
                      <p className="card-description">
                        <a href="#" className="policylink">Privacy Policy</a>
                      </p>
                      <div className="row">
                        <div className="col-md-6">
                          <button type="submit" className="btn btn-primary me-2 savebtn"
                            onClick={addPlatform}>ADD</button>
                        </div>
                        <div className="col-md-6">
                          <button className="btn btn-light me-2 savebtn">Cancel</button>
                        </div>
                      </div>

                    </form>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Platform </h4>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input type="text" className="form-control form-control-lg"
                            onChange={handleChange} value={searchText} name="searchText" placeholder='Search ' />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <button type="submit" className="btn btn-primary me-2 savebtn" onClick={searchRecord}>
                            Search
                          </button>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="form-group">
                          <button type="submit" className="btn btn-primary me-2 savebtn" onClick={clearSearch}>
                            Clear Search
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Sequence Name</th>
                            <th>Platform Name</th>
                            <th>Created</th>
                            {/* <th>Status</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {platformList.length > 0 && platformList.map((data, index) => (<tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.sequence_name}</td>
                            <td>{data._url}</td>
                            <td><Moment format="DD-MM-YYYY">{data.created_on}</Moment></td>
                            {/* <td><label className="badge badge-danger">{data.status_id}</label></td> */}
                            <td>
                              <button type="submit" className="btn btn-primary btn-sm savebtn " onClick={() => editPlatform(data)}>Edit</button>
                            </td>
                            <td>
                              {data.is_verified ? <button type="submit" className="btn btn-primary btn-sm savebtn">Verified</button> : <button type="submit" className="btn btn-primary btn-sm savebtn" onClick={() => Verify(data)}>Verify</button>}
                            </td>
                          </tr>))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />

        </div>

      </div>


    </>
  )
}